import React, { PureComponent } from 'react'

import './styles.scss'

export default class PostLoader extends PureComponent {
  render() {
    return (
      <div className = 'post-loader'>
        <div className = 'post-loader-title' />
        <div className = 'post-loader-splash' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-spacer' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-spacer' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-spacer' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-spacer' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-spacer' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-spacer' />
        <div className = 'post-loader-preview-text' />
        <div className = 'post-loader-preview-text' />
      </div>
    )
  }
}
